import React from "react";
import "./erpIntegration.css";
import erpImage from "../../../assets/service-pictures/erp-integration.jpg"
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import EnsureSecurity from "./EnsureSecurity";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";
import Modules from "./Modules";

const ERPIntegration = () => {
  return (
    <div className="erp-integration-service-wrapper">
      <Particles title="ERP Integration" image={erpImage} />
      <HeroSection />
      <Modules />
      <OurApproach />
      <EnsureSecurity />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default ERPIntegration;
